import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData_AddAtt {
  current_lang: string;
}

@Component({
  selector: 'app-add-video',
  templateUrl: './add-video.component.html',
  styleUrls: ['./add-video.component.scss']
})
export class AddVideoComponent {
  videoUrl = '';
  wrongUrl = false;
  videoId = '';
  src = '';

  constructor(public dialogRef: MatDialogRef<AddVideoComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData_AddAtt) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  checkUrlPattern() {
    const regex = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/gm;
    const match = regex.exec(this.videoUrl);
    if (!!match && match?.length > 5) {
      this.wrongUrl = false;
      this.videoId = match[5];
    } else {
      this.wrongUrl = true;
    }
  }

  newFile() {
    return {
      name: this.videoUrl,
      file_byte: `https://www.youtube.com/embed/${this.videoId}`,
      file_type: 'video',
      source: null,
      title_audio: false,
      avatar: false
    };
  }
}
